// Slide counter shown in the app header. Format: "current/total" with vertical
// "(v+1)" appended when the speaker is on a vertical sub-slide.

export default {
  id: 'slide-counter',
  slot: 'slide-counter',
  mount({ slot, deck }) {
    slot.innerHTML = `<span data-role="counter">—</span>`;
    const el = slot.querySelector('[data-role="counter"]');

    const update = () => {
      if (!deck.reveal) return;
      const i = deck.getIndices();
      const horiz = deck.reveal.getHorizontalSlides?.() || [];
      const total = horiz.length;
      let txt = `${i.h + 1}/${total}`;
      if ((i.v ?? 0) > 0) txt += ` · ${i.v + 1}`;
      el.textContent = txt;
    };

    deck.onReady(() => {
      update();
      deck.reveal.on('slidechanged', update);
    });
  },
};
